import { render, staticRenderFns } from "./57baoyevideo.vue?vue&type=template&id=5bb16010&"
import script from "./57baoyevideo.vue?vue&type=script&lang=js&"
export * from "./57baoyevideo.vue?vue&type=script&lang=js&"
import style0 from "./57baoyevideo.vue?vue&type=style&index=0&id=5bb16010&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports